module.exports = __webpack_public_path__ + "static/media/project15.e77e5196.jpg";